import { ContactKind, MessagePart, partsContactKinds, scanContact } from '@curbnturf/helpers';

/**
 * The admin app's view of contact sharing in messages. The detection itself lives in
 * `@curbnturf/helpers` (scanContact), shared with the server's contact-share list.
 */
export type { ContactKind, MessagePart };

export const CONTACT_LABELS: Record<ContactKind, string> = {
  phone: 'Shares a phone number',
  email: 'Shares an email address',
  link: 'Shares a link',
  payment: 'Mentions paying off-site',
};

/** Recent results by message text: templates ask on every render, and the patterns aren't cheap. */
const CACHE_SIZE = 500;
const cache = new Map<string, MessagePart[]>();

/** The message split into plain text and flagged pieces, in order. */
export function splitContact(text: string | null | undefined): MessagePart[] {
  const body = text ?? '';
  const known = cache.get(body);
  if (known) return known;
  const parts = scanContact(body);
  if (cache.size >= CACHE_SIZE) cache.delete(cache.keys().next().value as string);
  cache.set(body, parts);
  return parts;
}

/** The kinds of contact detail a message shares, once each, in a fixed order. */
export function contactKinds(text: string | null | undefined): ContactKind[] {
  return partsContactKinds(splitContact(text));
}
